<template>
  <div id="app">
      <div v-if="logined" style="height: calc(100% - 30px)">
        <div id="nav">
          <router-link to="/">升级设置</router-link> |
          <router-link to="/logs">升级日志</router-link> |
          <router-link to="/result">升级结果</router-link>
        </div>
        <Card class="content" :shadow="false">
          <router-view/>
        </Card>
      </div>
      <div v-else style="width: 100%; display: flex; justify-content: center">
        <login @login-success="loginSuccess"></login>
      </div>
    <div class="footer">
      <div>
        Copyright © 2018 深圳市微特芯科技有限公司 All Rights Reserved 备案号：
        <a rel="nofollow" href="http://beian.miit.gov.cn/" target="_blank">粤ICP备14017168号-5</a>
      </div>
    </div>
  </div>
</template>

<script>
  import login from './views/login.vue'
  import {deepCopyObject} from "./utility/util.js"

  export default {
    components: {
      login
    },
    data() {
      return {
        logined: false,
          code: '',
      }
    },
    created() {
      if (sessionStorage.logined) {
        this.logined = true;
        deepCopyObject(this.$coreData, JSON.parse(sessionStorage.coreData));
      }
    },
    methods: {
      loginSuccess() {
        this.logined = true;

        //保存登录信息,只能保存字符串
        sessionStorage.logined = 'true';
        sessionStorage.coreData = JSON.stringify(this.$coreData);
      }
    }
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  height: 100%;
  color: #2c3e50;
}

.footer {
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.content {
  margin: 0 60px 20px 60px;
  height: calc(100% - 80px);
  overflow-y: auto;
  overflow-x: hidden;
  text-align: left;
}

.content .ivu-card-body {
    height: 100%;
}

#nav {
  padding: 20px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
